import Vue from 'vue'
// import { log } from 'util';
// Set filter here
Vue.filter("numberFormat", function(value) {
  if(!value && value!==0) {
    return '--'
  } else if(typeof value == 'string') {
    return value
  } else {
    let val = (value / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
})

Vue.filter("numberFormat2", function(value) {
  if(!value && value!==0) {
    return '--'
  } else if(typeof value == 'string') {
    return value
  } else {
    let result = value.toString().match(/[0-9]+(.[0-9]{0,2})?/g);
    if (result[0]) {
      return result[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return value.toString();
  }
})

Vue.filter("numberFormat3", (num,noUnit,isNTD) => {
  if (num / 10000 >= 1) {
    const decNum = num / 10000;
    let val;
    // let val = noPrecision?(Math.floor(decNum * 100) / 100).toString():(Math.floor(decNum.toPrecision(4) * 100) / 100).toString();
    if(decNum.toString().indexOf('.') > -1){
      const tempVal = decNum.toString().split('.');
      val = tempVal[0] +'.'+ tempVal[1].substr(0,2);
    }else{
      val = decNum.toString()
    }
    if(val.split('.') && val.split('.')[1] === '00'){
      val = val.split('.')[0];
    }
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+(noUnit?'':'萬');
  } else {
    //20211005新增外幣判斷
    let val = (num / 1).toFixed(isNTD?0:2);
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+(noUnit?'':'元');
  }
})

Vue.filter('hundredFloor', amount => {
  let strAmount = amount.toString().split('.')[0];
  const length = strAmount.length;
  if (length > 5) {
    const begin = strAmount.substr(0, length - 2);
    return begin + '00';
  } else {
    return amount;
  }
});


Vue.filter("numberUnitFormat", function(value) {
  if(!value && value!==0) {
    return '--'
  } else {
    let val = (value.replace(/[^\d]/g,'') / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + value.replace(/\d/g,'');
  }
})

Vue.filter("addressFormat", function(value) {
  if(!value) {
    return '--'
  } else if(typeof value == 'string') {
    return value
  } else {
    return value.toString().replace(/,/g, '')
  }
})

Vue.filter("yearsSliceFormat", function(value) {
  if(!value && value!==0) {
    return '--'
  } else (typeof value == 'string') 
    return value.slice(0,3)
  
})

Vue.filter("phoneFormat", function(value) {
  if(!value) {
    return '--'
  } else if(typeof value == 'string') {
    return value
  } else {
    let starRegex = /(\*)/
    let mergeStr = value.toString().replace(/,/g, '-')
    let phonePattern = new RegExp('[0-9]+(-[0-9]+)?(-[0-9]+)?')
    let resultStr = phonePattern.exec(mergeStr)
    let result = mergeStr[mergeStr.search(starRegex)]
    if(result == "*"){
      return mergeStr
    }else{
      return resultStr ? resultStr[0] : ''
    }
  }
})

Vue.filter("dateToROCdateFormat", function(value) {
  let isValueCorrect = /^[\d]{4}-[\d]{2}-[\d]{2}$/
  if(!value || !isValueCorrect.test(value) || value == '1911-01-01') return '— —'
  let year = String(Number(value.slice(0, 4)) - 1911)
  return `${year}/${value.slice(5, 7)}/${value.slice(8, 10)}`
})

Vue.filter("dateFormat", function(value) {
  let validateEmptyA = /\d{4}\-/g
  let validateEmptyB = /\d{4}\//g
  if (!value || value==='' || !(validateEmptyA.test(value) || validateEmptyB.test(value))) return '— —'
  let dt = window.moment(value)
  let m = dt.month() + 1 < 10 ? `0${dt.month() + 1}` : dt.month() + 1
  let d = dt.date() < 10 ? `0${dt.date()}` : dt.date()
  return `${dt.year() - 1911}/${m}/${d}`
})

Vue.filter("fileFormat", function(value) {
  let file = String(value)
  return file.split(".")[0]
})

Vue.filter("ymdsDateFormat", function(value) { //顯示年月日秒
  let validateEmptyA = /\d{4}\-/g
  let validateEmptyB = /\d{4}\//g
  if (!value || value==='' || !(validateEmptyA.test(value) || validateEmptyB.test(value))) return '— —'
  let dt = window.moment(value)
  let m = dt.month() + 1 < 10 ? `0${dt.month() + 1}` : dt.month() + 1
  let d = dt.date() < 10 ? `0${dt.date()}` : dt.date()
  let h = dt.hours() < 10 ? `0${dt.hours()}` : dt.hours()
  let M = dt.minutes() < 10 ? `0${dt.minutes()}` : dt.minutes()
  let s = dt.seconds() < 10 ? `0${dt.seconds()}` : dt.seconds()
  return `${dt.year() - 1911}/${m}/${d} ${h}:${M}:${s}`
})

Vue.filter("dateFormatWithHM", function(value) { //顯示年月日時分
  let validateEmptyA = /\d{4}\-/g
  let validateEmptyB = /\d{4}\//g
  if (!value || value==='' || !(validateEmptyA.test(value) || validateEmptyB.test(value))) return '— —'
  let dt = window.moment(value)
  let m = dt.month() + 1 < 10 ? `0${dt.month() + 1}` : dt.month() + 1
  let d = dt.date() < 10 ? `0${dt.date()}` : dt.date()
  let h = dt.hours() < 10 ? `0${dt.hours()}` : dt.hours()
  let M = dt.minutes() < 10 ? `0${dt.minutes()}` : dt.minutes()
  return `${dt.year() - 1911}/${m}/${d} ${h}:${M}`
})

Vue.filter("ymFormat",function(value) { //年月轉換
  if (!value || value==='' ){
   return '— —'
  // eslint-disable-next-line no-empty
  }else{
   let date = String(value)
   return date.slice(0,2)+"/"+date.slice(2,4)
  }
})

Vue.filter("rocYmFormat",function(value) { //保留民國年月
  if (!value || value == '— —' || value ===''){
   return '— —'
  } else {
   return value.substring(0, value.length - 3)
  }
})

Vue.filter("emptyField", function(value) {
  return ((value!==0 && !value) || value === '') ? '— —' : value
})
Vue.filter("pointFormat", function(value) {
  if((value!==0 && !value) || value === ''){
    return '— —' 
  }
  // const re = /([0-9] .[0-9]{2})[0-9]*/;
    return Number(value.match(/^\d+(?:\.\d{0,1})?/))
    // return value.replace(re,"$1");
  
})
Vue.filter("emptyDashField", function(value) {
  return ((value!==0 && !value) || value === '') ? '-' : value
})

Vue.filter("sexFormat", function(value) { //性別驗證
  let re = /^[A-Z]/ ;
  re.test(value)
  if(value!=undefined){
    if(value.slice(1,2)=='1' && re.test(value)){
       
      return '男' 
     }else if(value.slice(1,2)=='2' && re.test(value)){
       
      return '女'
     }
  }else{

    return '— —'
    }
})

Vue.filter("homeTelFormat", function(value) { //住家電話
  if(!value || value==='' || value=='-'){
    return '— —' 
   }
    return value
})

Vue.filter("corpTelFormat", function(value) { //公司電話
  if(!value || value==='' ||value=='-#'){
     
    return '— —' 
   }
    return value
})

Vue.filter("newTelFormat", function(value) { //去除－＃
  if(!value || value===''){
     
    return '— —' 
   }
    return value.slice(1,11)
})

Vue.filter("ageCounter", function(value) {
  if(value === '' || value === '--'){
    return '— —'
  }else{
    let dt = window.moment(value)
    let today = window.moment()
    return today.year() - dt.year()
  }
  
});

//  名國年計算歲數
Vue.filter("ageCounterDe", function(value) {
  if(value === '' || value === '--'){
    return '— —'
  }else{
    let date =  value.split('/')
    date[0] = date[0] - 0 + 1911
    date = date.join('/')
    let dt = window.moment(date)
    let today = window.moment()
    return today.year() - dt.year()
  }
  
});

Vue.filter("benefitFormat", function(value) {
  let str = []
  if(value.annuity){
    str.push(`<span>年金：${value.annuity}</span>`)
  }
  if(value.maturitybenefit){
    str.push(`<span>滿期：${value.maturitybenefit}</span>`)
  }
  if(value.deathbenefit){
    str.push(`<span>身故：${value.deathbenefit}</span>`)
  }
  if(value.birthdaygoodwishbenefit){
    str.push(`<span>祝壽：${value.birthdaygoodwishbenefit}</span>`)
  }
  if(str.join('') === ''){
    return '— —'
  }else{
    return str.join('<br>')
  }
});

Vue.filter("slashDateFormat", function(value) {
  
  if (!value || value==='') {return '— —'
  }else{
    let newVal = value.split('')
    let newD = newVal.splice(newVal.length - 2,2)
    let newM = newVal.splice(newVal.length - 2,2)
    newVal = newVal.join('')
    newM = newM.join('')
    newD = newD.join('')
    return `${newVal}/${newM}/${newD}`
  }
})
Vue.filter("getPhoneNum", function(value) {
  if(!value || value==='') return '— —'
  let num = value.split('#')
  return num[0]
})
Vue.filter("getPhoneExt", function(value) {
  
  if(!value || value==='') return '— —'
  let ext = value.substring(value.lastIndexOf("#")+1)
  return ext
})

Vue.filter("dateFormatRemoveHMS", function(value){
  if (!value || value==='') return '— —'
  let dt = window.moment(value)
  let m = dt.month() + 1 < 10 ? `0${dt.month() + 1}` : dt.month() + 1
  let d = dt.date()
  return `${dt.year()}/${m}/${d}`
})

Vue.filter("dateFormatStart", function(value){
  if (!value || value==='') return '— —'
  let newData = value.split('-')
  if(newData[0][0] == '0') {
    newData[0] = newData[0].substr(1)
  }
  newData = newData.join('/')
  return newData
})

Vue.filter("dateFormatEnd", function(value){
  if (!value || value==='') return '— —'
  let newData = value.split('-')
  if(newData[0][0] == '0') {
    newData[0] = newData[0].substr(1)
  }
  newData[0] = parseInt(newData[0])+1
  newData = newData.join('/')
  return newData
})

//  過濾 客戶標記
Vue.filter("IDmarkFormat", function(value){
  if(!value || value.trim() == '' || value == '0') {return ''}
  
  let newData = []
  if(value.includes('G')){
    newData.push('黃金VIP')
  }
  if(value.includes('P')){
    newData.push('白金VIP')
  }
  if(value.includes('D')){
    newData.push('鑽石VIP')
  }
  // if(value.includes('O')){
  //   newData.push('1年未接觸')
  // }
  // if(value.includes('T')){
  //   newData.push('2年未接觸')
  // }
  if(value.includes('S')){
    newData.push('密戶')
  }
  if(value.includes('E')){
    newData.push('未訪件調撥')
  }
  if(value.includes('2')){
    newData.push('自招未訪件')
  }
  if(value.includes('4')){
    newData.push('準自招未訪件')
  }
  if(value.includes('7工提供直效')){
    newData.push('7工提供直效')
  }
  if(value.includes('10工提供直效')){
    newData.push('10工提供直效')
  }
  if(value.includes('6月提供直效')){
    newData.push('6月提供直效')
  }
  if(value.includes('10月提供直效')){
    newData.push('10月提供直效')
  }
  return newData.join(',')
})

// 移除副檔名
Vue.filter("removeExten", function(val){
  if(val){
    let ptn = /\..*/g
    return val.replace(ptn, '')
  }else{
    return val
  }
})

//姓名資安遮蔽
Vue.filter("getMaskName", function (val) {
  if (val && val.trim() && val !== '— —') {
    let maskName = ''
    let pattern = /^[a-zA-Z0-9]+$/
    val = val.trim()
    let isOverSize = stringBytes(val, false, 13) > 13
    if (pattern.test(val) ) {
      isOverSize = stringBytes(val, false, 12) > 12
      let len = isOverSize ? '12' : val.length
      //姓名為英文拼音
      if (len > 5) {
        if(len > 8){
          maskName = val.substring(0,4)
          for (let i = 0; i < len - 8; i++) {
            maskName += 'O'
          }
          maskName += val.substring(len - 4,len)
        } else {
          maskName = val.substring(0,2)
          for (let i = 0; i < len - 4; i++) {
            maskName += 'O'
          }
          maskName += val.substring(len - 2,len)
        }
      } else {
      if (len < 4) {
        maskName = val.substring(0,1)+'OO'
      } else {
        maskName = val.substring(0,len - 3)+'OO'+val.substring(len -1,len)
      }
      }
    } else {
      let len = isOverSize ? '6' : val.length
      if (len === 1) {
        maskName = val
      } else if (len === 2) {
        maskName = val.substring(0, 1) + 'O'
      } else if (len === 3) {
        maskName = val.substring(0, 1) + 'O' + val.substring(2, 3)
      } else if (len >= 4) {
        maskName = val.substring(0, 2)
        for (let i = 0; i < len - 3; i++) {
          maskName += 'O'
        }
        maskName += val.substring(len - 1, len)
      }
    }
    if (isOverSize) {
      maskName += '...'
    }
    return maskName
  } else {
    return val
  }
})

//身分證資安遮蔽
Vue.filter("getMaskID", function (val) {
  if (val && val.trim() && val !== '— —' && val !== '一一' && val !== '一 一') {
    let len = val.length
    return val.substring(0, 4) + '***' + val.substring(len - 3, len)
  } else {
    return val
  }
})

//手機資安遮蔽
Vue.filter("getMaskMobile", function (val) {
  if (val && val.trim() && val !== '— —' && val !== '一一' && val !== '一 一') {
    val = val.trim()
    let len = val.length
    return val.substring(0, 4) + '****' + val.substring(len - 2, len)
  } else {
    return val
  }
})

//電話資安遮蔽
Vue.filter("getMaskPhone", function (val) {
  if (val && val.trim() && val !== '— —' && val !== '一一' && val !== '一 一') {
    val = val.trim()
    let len = val.length
    return val.substring(0, len - 7) + '****' + val.substring(len - 2, len)
  } else {
    return val
  }
})

//生日資安遮蔽
Vue.filter("getMaskBirthday", function (val) {
  if (val && val.trim() && val !== '— —' && val !== '一一' && val !== '一 一') {
    val = val.trim()
    return val.substring(0, val.length - 2) + '**'
  } else {
    return val
  }
})

//地址資安遮蔽
Vue.filter("getMaskAddress", function (val) {
  if (val && val.trim() && val !== '— —' && val !== '一一' && val !== '一 一') {
    val = val.trim()
    let pattern = /[0-9]+/
    let len = val.length
    let firstWords = val.substring(0, 3)
    if (pattern.test(firstWords)) {
      //前3碼若為數字，表示包含郵遞區號
      val = val.substring(3, len)
    } else {
      firstWords = ''
    }
    let maskAddr = ''
    for (let i = 0; i < val.length - 9; i++) {
      maskAddr += '*'
    }
    return firstWords + val.substring(0, 9) + maskAddr
  } else {
    return val
  }
})

//保單號碼資安遮蔽
Vue.filter("getMaskPolicyNumber", function (val) {
  if (val && val !== '— —' && val !== '一一' && val !== '一 一' && String(val).replace(/(^s*)|(s*$)/g, "").length !== 0) {
    const len = val.length
    if( len <= 4){
      return '*'.repeat(len)
    }
    //前面保留多少個明碼的計算方式
    const index = Math.floor((len - 4) / 2) ; 
    return val.substring(0, index) + "****" + val.substring(index+4)
  } else {
    return val
  }
})

//計算字元長度 (字串, 是否檢查, 檢查的長度)
var stringBytes = function (c, isSub, size) {
  var n = c.length, s;
  var len = 0;
  for (var i = 0; i < n; i++) {
    s = c.charCodeAt(i);
    while (s > 0) {
      len++;
      s = s >> 8;
      if (isSub && len > size) {
        return i;
      }
    }
  }
  return len;
}

//保費繳款方式(1/人工收費 2/扣薪 3/轉帳 4/卡扣 6/自繳)
Vue.filter("payTypeFormat", function (val) {
  if (val && val.trim()) {
    let showText = "";
    if(val == "1") {
      showText = "人工收費";
    } else if (val == "2") {
      showText = "扣薪";
    } else if (val == "3") {
      showText = "轉帳";
    } else if (val == "4") {
      showText = "卡扣";
    } else if (val == "6") {
      showText = "自繳";
    }
    return showText;
  } else {
    return "";
  }
})

//失聯回報狀態(5/遷址不明 6/查無此址 10/電話不正確)
Vue.filter("contactFormat", function (val) {
  if (val && val.trim()) {
    let trimVal = val.trim();
    let showText = "輸入";
    if(trimVal == "5") {
      showText = "遷址不明";
    } else if (trimVal == "6") {
      showText = "查無此址";
    } else if (trimVal == "10") {
      showText = "電話不正確";
    }
    return showText;
  } else {
    return "輸入";
  }
})

//強制調撥總表，替換顯示文字
Vue.filter("getCedvnmText", function(val) {
  if (!val || !val.trim()) {
    return;
  }
  let text = val;
  if (val == "CEDVNM_1") {
    text = "專招";
  } else if (val == "CEDVNM_2") {
    text = "展業";
  } else if (val == "CEDVNM_3") {
    text = "合計";
  } else if (val == "CEDVNM_4") {
    text = "業務通路";
  }
  return text;
})
